import React from 'react';
import { connect } from "react-redux"
import PropTypes from 'prop-types';
import { Link }  from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/CheckCircleOutline'
import Fab from '@material-ui/core/Fab';
import { resetAddMember }from '../../../../store/Actions/memberActions/memberActions'


function getModalStyle() {
  const top = 50;
 const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: 'none',
    textAlign: 'center'
  },
  close: {
      float: 'right',
      marginTop: '-24px',
      marginRight: '-24px',
      boxShadow: 'none',
      backgroundColor: 'white',
  },
  check: {
      color: '#23da23',
      fontSize: '50px',
      margin: '0 auto'
  }
});

class SimpleModal extends React.Component {
   
  state = {
    open: this.props.open
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.resetAddMember()
  };
   handleReset = (e) => {
     this.props.resetForm()
     this.handleClose()
   }

  render() {
    const { classes, uniqueId } = this.props;
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
        > 
          <div style={getModalStyle()} className={classes.paper}>
          <Fab size="small" onClick={this.handleClose} className={classes.close} aria-label="Close">
          <CloseIcon />
        </Fab>
          <CheckIcon  className={classes.check}/>
            <Typography variant="h6" id="modal-title">
            You successfully added new member
            </Typography>
           <Link 
                to={{
                    pathname:'/test',
                    uniqueId
                }}
           >
           <Button   onClick={this.handleClose}>Run Test for this member</Button>
           </Link>
            <Button   onClick={this.handleReset}>Add New Member</Button>
            
            <SimpleModalWrapped />
          </div>
        </Modal>
      </div>
    );
  }
}

SimpleModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

// We need an intermediary variable for handling the recursive nesting.
const SimpleModalWrapped = withStyles(styles)(SimpleModal);

//export default SimpleModalWrapped;

export default connect(null, { resetAddMember })(SimpleModalWrapped)